import type { CheerioAPI } from "cheerio";
import type { Url } from "../../data-model/primitives.js";
import { resolveUrl } from "../../utils/url.js";

/** Resolve a cover image URL from `selector`, trying `src` then `data-src`. */
export function extractCoverUrl($: CheerioAPI, selector: string, baseUrl: Url): Url | undefined {
  const el = $(selector).first();
  const raw = el.attr("src") ?? el.attr("data-src");
  return raw ? resolveUrl(baseUrl, raw) : undefined;
}
